import { ORCHARD_BIT_POLICY } from './orchard-bit'
import { RAINY_ROOFTOP_POLICY } from './rainy-rooftop'
import { LUNAR_CAMP_POLICY } from './lunar-camp'
import { POCKET_REEF_POLICY } from './pocket-reef'
import type { PolicyDocument } from './types'
import { CHEOTJANGMYEON_POLICY } from './cheotjangmyeon'
import { EASY_AIR_SCREEN_POLICY } from './easy-air-screen'
import { EASY_AIR_SCREEN_LITE_POLICY } from './easy-air-screen-lite'
import { LIFEDECK_POLICY } from './lifedeck'
import { PEEKMO_POLICY } from './peekmo'
import { RETYPE_POLICY } from './retype'
import { SIHEOMBOSO_POLICY } from './siheomboso'
import { SOULWELD_POLICY } from './soulweld'
import { SOUNDTETHER_POLICY } from './soundtether'
import { TIDECIPHER_POLICY } from './tidecipher'
import { VELARIA_POLICY } from './velaria'
import { ISLEINK_POLICY } from './isleink'
import { TUCKED_POLICY } from './tucked'
import { SNOWBACK_POLICY } from './snowback'
import { KEYWRIGHT_POLICY } from './keywright'
import { HIVEHOLD_POLICY } from './hivehold'
import { BARGAINSMITH_POLICY } from './bargainsmith'
import { PLUMBLINE_POLICY } from './plumbline'
import { TYPEPATH_POLICY } from './typepath'
import { KKIMSAE_POLICY } from './kkimsae'
import { TTORYEOT_POLICY } from './ttoryeot'
import { MEWTIDY_POLICY } from './mewtidy'
import { MOSS_BYTE_POLICY } from './moss-byte'
import { KITE_POLICY } from './kite'

/**
 * 서비스가 늘면 문서 파일 하나 + 여기 한 줄. slug = 서비스명(서브도메인)과 맞춘다.
 *
 * **줄어들 때도 여기 한 줄이다.** Barrowsweeper 방침은 뺐다 (2026-08-24) — 게임이
 * Tidecipher 로 통합되며 폐기됐고 스토어에 공개된 적이 없다. 공개 이력이 없는 제품의
 * 방침을 남겨 두면 `/privacy` 와 sitemap 이 존재하지 않는 앱을 가리킨다.
 * 이미 배포된 앱의 방침은 이렇게 지우지 않는다 — 쓰던 사람이 있으면 문서는 남는다.
 */
export const POLICIES: readonly PolicyDocument[] = [
  SOUNDTETHER_POLICY,
  EASY_AIR_SCREEN_POLICY,
  EASY_AIR_SCREEN_LITE_POLICY,
  CHEOTJANGMYEON_POLICY,
  SIHEOMBOSO_POLICY,
  RETYPE_POLICY,
  PEEKMO_POLICY,
  LIFEDECK_POLICY,
  VELARIA_POLICY,
  ISLEINK_POLICY,
  TUCKED_POLICY,
  TIDECIPHER_POLICY,
  SOULWELD_POLICY,
  SNOWBACK_POLICY,
  KEYWRIGHT_POLICY,
  HIVEHOLD_POLICY,
  BARGAINSMITH_POLICY,
  PLUMBLINE_POLICY,
  TYPEPATH_POLICY,
  KKIMSAE_POLICY,
  TTORYEOT_POLICY,
  MEWTIDY_POLICY,
  MOSS_BYTE_POLICY,
  ORCHARD_BIT_POLICY,
  RAINY_ROOFTOP_POLICY,
  LUNAR_CAMP_POLICY,
  POCKET_REEF_POLICY,
  KITE_POLICY,
]

export function findPolicy(slug: string): PolicyDocument | undefined {
  return POLICIES.find((policy) => policy.slug === slug)
}

export type { PolicyDocument, PolicySection, PolicyTable } from './types'
